import { Outlet } from "react-router-dom";
import { TopNav } from "./TopNav";

export function AppShell() {
  return (
    <div>
      <TopNav />
      <Outlet />
    </div>
  );
}
